import { useQuery } from "react-query"
import { useFilter } from "../../../filter/hook"
import dataAPI from "../../services/dataAPI"

export default function useLastHeatBeat(device_name?: string) {
  const { filter } = useFilter()
  
  const heartbeatQuery = useQuery({
    queryKey: ['heartbeat-meter', filter.device_name, device_name],
    queryFn: () => dataAPI.getLastHeartbeatSingleCounter(filter, device_name)
  })

  // Fonction pour formater la date
  const formatDate = (dateString: string | undefined): Date | null => {
    if (!dateString) return null;
    try {
      const date = new Date(dateString);
      return date
    } catch (error) {
      return null;
    }
  };

  // Fonction pour déterminer si le compteur est en ligne
  const isOnline = (): boolean => {
    const lastHeartbeat = heartbeatQuery.data?.[0]?.Time;
    if (!lastHeartbeat) return false;
    
    const lastHeartbeatDate = formatDate(lastHeartbeat);
    if (!lastHeartbeatDate) return false;
    
    const now = new Date();
    const twoHoursAgo = new Date(now.getTime() - 2 * 60 * 60 * 1000); // 2 heures en millisecondes
    
    return lastHeartbeatDate > twoHoursAgo;
  };

  // Fonction pour obtenir le temps écoulé depuis le dernier heartbeat
  const getTimeSinceLastHeartbeat = (): string | null => {
    const lastHeartbeat = heartbeatQuery.data?.[0]?.Time;
    if (!lastHeartbeat) return null;
    
    const lastHeartbeatDate = formatDate(lastHeartbeat);
    if (!lastHeartbeatDate) return null;
    
    const now = new Date();
    const diffInMs = now.getTime() - lastHeartbeatDate.getTime();
    const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
    const diffInHours = Math.floor(diffInMinutes / 60);
    const diffInDays = Math.floor(diffInHours / 24);
    
    if (diffInDays > 0) {
      return `Il y a ${diffInDays} jour${diffInDays > 1 ? 's' : ''}`;
    } else if (diffInHours > 0) {
      return `Il y a ${diffInHours} heure${diffInHours > 1 ? 's' : ''}`;
    } else if (diffInMinutes > 0) {
      return `Il y a ${diffInMinutes} minute${diffInMinutes > 1 ? 's' : ''}`;
    } else {
      return 'Maintenant';
    }
  };

  return {
    filter,
    heartbeatQuery: {
      data: heartbeatQuery.data,
      isLoading: heartbeatQuery.isLoading,
      isSuccess: heartbeatQuery.isSuccess,
      isError: heartbeatQuery.isError,
      error: heartbeatQuery.error,
      refetch: heartbeatQuery.refetch,
      isRefetching: heartbeatQuery.isRefetching
    },
    lastHeartbeatFormated: heartbeatQuery.data?.[0]?.Time ? formatDate(heartbeatQuery.data?.[0].Time) : null,
    isOnline: isOnline(),
    timeSinceLastHeartbeat: getTimeSinceLastHeartbeat(),
    isLoading: heartbeatQuery.isLoading
  }
}
